///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { switchMap, tap } from 'rxjs';
import { getSystemInfo, setSystemInfo } from '../system-info.actions';
import { HttpClient } from '@angular/common/http';
import { SystemInfoDTO } from '../../../../generated/shared-types.model';
import { AuthorizationManagerService } from '../../../auth/authorization-manager/authorization-manager.service';

@Injectable()
export class SystemInfoEffects {
    getSystemInfo$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(getSystemInfo),
            switchMap(() => this.httpClient.get<SystemInfoDTO>('api/system-info')),
            tap((systemInfo: SystemInfoDTO) => this.authorizationManagerService.setSystemInfo(systemInfo)),
            map((systemInfo: SystemInfoDTO) => setSystemInfo({ systemInfo }))
        );
    });

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly httpClient: HttpClient,
        private readonly authorizationManagerService: AuthorizationManagerService
    ) {}
}
